/* AUTOGENERATED FILE - DO NOT EDIT CONTENTS */

export const projectId = "xiotthneuoyptfiwofnx"
export const publicAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inhpb3R0aG5ldW95cHRmaXdvZm54Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjYzMzQyODAsImV4cCI6MjA4MTkxMDI4MH0.d1m4i80EZgIkvgQgf_u3pTW83SkMiBZ6ZgkTpG-2Ki4"